// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React from 'react';
import {createPortal} from 'react-dom';
import cn from 'classnames';
import styles from './styles.module.less';

interface i_settlement_notification_bar_props {
    is_visible: boolean;
    on_learn_more_click: ()=>void;
    portal_ref?: React.RefObject<HTMLDivElement>;
}

export const Settlement_notification_bar = (props:
    i_settlement_notification_bar_props)=>{
    const {is_visible, on_learn_more_click, portal_ref} = props;
    if (!is_visible)
        return null;
    const content = <div className={cn(styles.notification_bar)}>
      <div className={cn(styles.container)}>
        <span className={cn(styles.text)}>
          Class action settlement in CA (Dist. - TA) 62567-02-22
        </span>
        <button className={cn(styles.learn_more)}
          onClick={on_learn_more_click}>
          Learn more
        </button>
      </div>
    </div>;
    if (portal_ref?.current)
        return createPortal(content, portal_ref.current);
    return content;
};
